import React from 'react'
import Navbar from "../../components/NavBar/Index"
import AddCoupon from "../../components/AddCoupon/Index" 
const Index = () => {
  return (
    <div className='flex flex-1 flex-col overflow-hidden px-2 md:px-4'>
      <div className='flex-1 flex flex-col min-h-0 mt-2 overflow-hidden'> 
        <AddCoupon />
      </div>
    </div>
  )
}

export default Index